import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AppleLoginMine.css';

const AppleLoginMine = () => {
  const [isSDKLoaded, setIsSDKLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { account_id } = location.state || {};

  useEffect(() => {
    // Check if the SDK is loaded
    const checkSDKLoaded = () => {
      if (window.AppleID) {
        try {
          // Create a state object that includes the account_id if it exists
          const stateObj = {
            random: crypto.randomUUID(),
            ...(account_id && { account_id })
          };
          
          // Initialize Apple Sign-In
          window.AppleID.auth.init({
            clientId: process.env.REACT_APP_APPLE_CLIENT_ID || 'com.taptipgo',
            scope: 'name email',
            // Use the Django backend callback URL
            redirectURI: `${process.env.REACT_APP_DJANGO_API_URL}/api/apple-callback/`,
            state: JSON.stringify(stateObj), // Include account_id in state
            usePopup: true
          });
          setIsSDKLoaded(true);
        } catch (error) {
          console.error('Error initializing Apple Sign-In:', error);
        }
      } else {
        // If SDK is not loaded yet, try again in 100ms
        setTimeout(checkSDKLoaded, 100);
      }
    };

    checkSDKLoaded();

    // Cleanup function
    return () => {
      // Any cleanup if needed
    };
  }, [account_id]); // Add account_id as a dependency

  const handleAppleLogin = async () => {
    if (!isSDKLoaded) {
      console.error('Apple Sign-In SDK not loaded');
      return;
    }

    try {
      // Perform Apple Sign-In
      const data = await window.AppleID.auth.signIn();
      
      // Get the authorization code and ID token from the response
      const { authorization } = data;
      const { code, id_token, refresh_token } = authorization;

      // Make API call to your backend
      const response = await fetch(`${process.env.REACT_APP_DJANGO_API_URL}/api/apple_login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: id_token,
          code: code,
          refresh_token: refresh_token,
          ...(account_id && { account_id }) // Only include account_id if it exists
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        // Store token and user data
        localStorage.setItem('apple_token', id_token);
        if (refresh_token) {
          localStorage.setItem('apple_refresh_token', refresh_token);
        }
        if (responseData.token_expires_at) {
          localStorage.setItem('apple_token_expires_at', responseData.token_expires_at);
        }
        localStorage.setItem('user', JSON.stringify({ ...responseData, account_id: responseData.account_id }));
        
        // Navigate to onboarding with the account_id from the response
        navigate(`/${responseData.account_id}/onboarding`);
      } else {
        const errorText = await response.text();
        console.error('Apple login failed:', errorText);
        // Show error to user
        alert('Apple login failed. Please try again.');
      }
    } catch (error) {
      console.error("Apple login failed:", error);
      // Show error to user
      alert('Apple login failed. Please try again.');
    }
  };

  return (
    <div className="apple-login-wrapper">
      <button 
        className="apple-login-button"
        onClick={handleAppleLogin}
        disabled={!isSDKLoaded}
      >
        <img 
          src="/apple-logo.png" 
          alt="Apple logo" 
          className="apple-logo"
        />
        Continue with Apple
      </button>
    </div>
  );
};

export default AppleLoginMine; 